import React, { useState, useEffect, useCallback } from 'react';
import { Slider, withStyles } from '@material-ui/core';
import { Button,ButtonGroup } from 'react-bootstrap'


const CustomSlider = withStyles({
    valueLabel: {
        fontSize: '24px',
        fontWeight: 'bold',
    },
    markLabel: {
        fontSize: '18px',
        fontWeight: 'bold',
        color:'white'
    },
    thumb: {
        color:"white",
        display: true
    },
    track: {
        color:"white",
        height: 3,
        //borderRadius: 24
    },
    rail: {
        color:"gray",
        height: 3,
        //borderRadius: 24,
        opacity: 1
      }
})(Slider);

export const TimeSlider = ({ month, setMonth, year, setYear, startDate, endDate }) => {

    const [intervalId, setIntervalId] = useState(null);
    // const [prevValue, setPrevValue] = useState(1);
    const [value, setValue] = useState(0)
    const [isPlaying, setIsPlaying] = useState(false)


    // const handleChange = (event, newValue) => {
    //     if (!!newValue)
    //     {
    //         let dtg = valueToDtg(newValue)
    //         setYear(dtg.year)
    //         setMonth(dtg.month)
    //     }
    // };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const valueLabelFormat = (value) => {
        let dtg = valueToDtg(value)
        return `${dtg.year}-${dtg.month}`;
    };

    const dtgToValue = (year, month) => {
        let dyear = year - startDate.year()
        let value = dyear * 12 + month - 1
        return value
    }

    const valueToDtg = useCallback((value) => {
        let year = parseInt(value / 12)
        let month = value - year * 12 + 1
        year = year + startDate.year()

        return { 'year': year, 'month': month }
    },[startDate])



    // Start playing the slider
    // const handlePlay = () => {
    //     if (!intervalId) {
    //     const newIntervalId = setInterval(() => {
    //         setValue((prevValue) => (prevValue >= 100 ? 0 : prevValue + 1));
    //     }, 100);
    //     setIntervalId(newIntervalId);
    //     handleChange
    //     }
    // };

    const handlePlay = () => {
        setIsPlaying(true)
        if (!intervalId) {
            const newIntervalId = setInterval(() => {
                setValue((prevValue) => {
                    const newValue = prevValue >= dtgToValue(endDate.year(), endDate.month()+1) ? 0 : prevValue + 1;
                    // setPrevValue(prevValue); // Store the previous value
                    return newValue;
                });
            }, 100);
            setIntervalId(newIntervalId);
        }
    };

    // Stop playing the slider
    const handleStop = () => {
        setIsPlaying(false)
        if (intervalId) {
            clearInterval(intervalId);
            setIntervalId(null);
        }
    };

    useEffect(() => {
        return () => {
            // Cleanup the interval when the component is unmounted
            clearInterval(intervalId);
        };
    }, [intervalId]);

    useEffect(() => {

        let dtg = valueToDtg(value)
        setYear(dtg.year)
        setMonth(dtg.month)

    }, [value, setYear, setMonth, valueToDtg]);


    return (
        <div style={{width: '70vw', gap: '30px', minWidth: '400px'}} className="mx-auto d-flex flex-row flex-wrap justify-content-center">
            
                    <CustomSlider
                        key="timeslider"
                        value={value}
                        onChange={handleChange}
                        aria-labelledby="continuous-slider"
                        min={dtgToValue(startDate.year(), startDate.month() + 1)}
                        max={dtgToValue(endDate.year(), endDate.month() + 1)}
                        step={1}
                        marks={[
                            { value: dtgToValue(2020, 1), label: '2020' },
                            { value: dtgToValue(2025, 1), label: '2025' },
                            { value: dtgToValue(2030, 1), label: '2030' },
                            { value: dtgToValue(2035, 1), label: '2035' },
                            { value: dtgToValue(2040, 1), label: '2040' },
                            { value: dtgToValue(2045, 1), label: '2045' },
                            { value: dtgToValue(2050, 1), label: '2050' },
                        ]}
                        
                        valueLabelDisplay="off"
                        valueLabelFormat={valueLabelFormat}
                        style={{width: '40vw', minWidth: '365px'}}
                    />
               
                        <ButtonGroup style={{minWidth: '365px'}}>
                        <Button variant="secondary" onClick={() => setValue(value-1>=0?value-1:0)}> {"- month"} </Button>
                        <Button variant="secondary" onClick={() => setValue(value+1)}> {"+ month"} </Button> 
                        <Button variant="secondary" onClick={() => setValue(value-12>=0?value-12:0)}> {"- year"} </Button>
                        <Button variant="secondary" onClick={() => setValue(value+12)}> {"+ year"} </Button> 
                        {isPlaying ?
                        <Button variant="secondary" onClick={handleStop}>stop</Button>
                        :
                        <Button variant="secondary" onClick={handlePlay}>play</Button>
                        }

                        </ButtonGroup>

            {/* <Tooltip title={valueLabelFormat(value)}>
                <div style={{ textAlign: 'center' }}>
                    <p>{valueLabelFormat(value)}</p>
                </div>
            </Tooltip> */}

        </div>
    )
}
